var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-container',{staticClass:"content"},[_c('el-container',[_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }